module.exports = __webpack_public_path__ + "img/Screenshot_2021-10-28-16-20-42-211_com.pinkcoffee.sexbattle.f09d1ecf.jpg";